// TODO: Move FunnelQuestionCategory to './category'
export enum FunnelQuestionCategory {
  Field = 'Field',
  Position = 'Position',
  EducationAndTraining = 'Education & Training',
  AboutYou = 'About you',
  Register = 'Register',
}

export enum FunnelQuestion {
  NursingAreaWorking = 'NursingAreaWorking',
  EmployeeType = 'EmployeeType',
  PositionDesired = 'PositionDesired',
  JobTitle = 'JobTitle',
  PositionDeputy = 'PositionDeputy',
  /* eslint-disable eslint-compat/naming-convention */
  AQualification = 'AQualification',
  BQualification = 'BQualification',
  BQualificationRecognition = 'BQualificationRecognition',
  CQualification = 'CQualification',
  CQualificationRecognition = 'CQualificationRecognition',
  DQualification = 'DQualification',
  DQualificationRecognition = 'DQualificationRecognition',
  /* eslint-enable eslint-compat/naming-convention */
  CaregiverQualification = 'CaregiverQualification',
  HaveDriverLicense = 'HaveDriverLicense',
  Locations = 'Locations',
  GermanSpeakingLevel = 'GermanSpeakingLevel',
  EmploymentType = 'EmploymentType',
  CanStartOn = 'CanStartOn',
  Registration = 'Registration',
  YearsOfExperience = 'YearsOfExperience',
  JobYearsOfExperience = 'JobYearsOfExperience',
  FurtherQualifications = 'FurtherQualifications',
  Departments = 'Departments',
  // This is not a real question, it's used to merge the questions together B/C/D/JobQualificationRecognition
  QualificationRecognition = 'QualificationRecognition',
  Qualifications = 'Qualifications',
  PermanentOrTemporary = 'PermanentOrTemporary',
  PersonalData = 'PersonalData',
  CvFiles = 'CvFiles',
  ExternalRegistration = 'ExternalRegistration',
  JobQualification = 'JobQualification',
  JobQualificationRecognition = 'JobQualificationRecognition',
  HighlightJobTitle = 'HighlightJobTitle',
  NameAndEmail = 'NameAndEmail',
  PhoneNumber = 'PhoneNumber',
  // A/B test: non-interactive matching-jobs preview shown before NameAndEmail
  PotentialJobsPreview = 'PotentialJobsPreview',
  // A/B test: optional district selection shown after Locations when a big city was chosen
  CityAreas = 'CityAreas',
}
